import { createContext } from "react";

const defaultState = {};

export const AppContext = createContext(defaultState);
